import { render } from "./Download.vue?vue&type=template&id=acbb8524"
import script from "./Download.vue?vue&type=script&setup=true&lang=js"
export * from "./Download.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Components/Common/TableFields/Download.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "acbb8524"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('acbb8524', __exports__)) {
    api.reload('acbb8524', __exports__)
  }
  
  module.hot.accept("./Download.vue?vue&type=template&id=acbb8524", () => {
    api.rerender('acbb8524', render)
  })

}


export default __exports__